import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'paghistorico',
    standalone: false
})

export class PaginadorPipe implements PipeTransform {

  transform(value: Array<{}>, page: number = 0): any {
    if (value) {
      return value.slice(page, page + 24);
    }
  }
}
